import { useQuery } from '@tanstack/react-query';
import { useApiMutation } from '../../api/mutations';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * #161: CrowdSec-Block-/Whitelisten. Nexus ist Quelle der Wahrheit; ein
 * Sync-Worker spielt die Listen periodisch als Decisions in die LAPI.
 * M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const BLOCK_FIXTURE = { decisions_enabled: true, items: [
  { id: 1, value: '203.0.113.66', scope: 'Ip', reason: 'orbit-blocklist', enabled: true, expires_at: null, last_synced_at: new Date().toISOString(), created_by: 'operator', created_at: new Date().toISOString() },
] };
const ALLOW_FIXTURE = { decisions_enabled: true, items: [
  { id: 1, value: '10.0.0.0/8', scope: 'Range', reason: 'internes Netz', enabled: true, last_synced_at: null, created_by: 'operator', created_at: new Date().toISOString() },
] };

export function useBlocklist() {
  const fx = useFixturesMode();
  return useQuery({
    queryKey: ['crowdsec-blocklist', fx ? 'fixture' : 'live'],
    queryFn: async () => { if (fx) { await fixtureDelay(); return BLOCK_FIXTURE; } return nexusFetch('/v1/admin/crowdsec/blocklist'); },
    refetchInterval: 60_000,
  });
}
export function useAllowlist() {
  const fx = useFixturesMode();
  return useQuery({
    queryKey: ['crowdsec-allowlist', fx ? 'fixture' : 'live'],
    queryFn: async () => { if (fx) { await fixtureDelay(); return ALLOW_FIXTURE; } return nexusFetch('/v1/admin/crowdsec/allowlist'); },
    refetchInterval: 60_000,
  });
}

export function useAddEntry(kind) {
  return useApiMutation({
    live: (_fetch, body) => nexusFetch(`/v1/admin/crowdsec/${kind}`, { method: 'POST', body }),
    fixture: (body) => ({ id: Date.now(), ...body }),
    invalidate: [`crowdsec-${kind}`],
    successMessage: (_, { value }) => `${value} hinzugefügt.`,
  });
}
export function useRemoveEntry(kind) {
  return useApiMutation({
    live: (_fetch, { id }) => nexusFetch(`/v1/admin/crowdsec/${kind}/${encodeURIComponent(id)}`, { method: 'DELETE' }),
    fixture: ({ id }) => ({ ok: true, id }),
    invalidate: [`crowdsec-${kind}`],
    successMessage: () => 'Eintrag entfernt.',
  });
}
export function useSyncNow() {
  return useApiMutation({
    live: () => nexusFetch('/v1/admin/crowdsec/sync', { method: 'POST' }),
    fixture: () => ({ ok: true, applied: 1, cleared: 0, failed: 0 }),
    invalidate: ['crowdsec-blocklist', 'crowdsec-allowlist'],
    successMessage: (r) => `Sync ausgelöst (${r?.applied ?? 0} appliziert, ${r?.cleared ?? 0} entfernt).`,
  });
}
